(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_f5aa838"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('countdown-timer')) {
    customElements.define(
      'countdown-timer',
      class CountdownTimer extends HTMLElement {
        connectedCallback() {
          this.end = parseInt(this.dataset.end, 10) * 1000;
          if (!this.end) return;

          this.els = {
            days: this.querySelector('[data-days]'),
            hours: this.querySelector('[data-hours]'),
            minutes: this.querySelector('[data-minutes]'),
            seconds: this.querySelector('[data-seconds]'),
          };

          this.onVisible = () => {
            if (!document.hidden) this.tick();
          };
          document.addEventListener('visibilitychange', this.onVisible);

          this.tick();
        }

        disconnectedCallback() {
          clearTimeout(this.timeout);
          document.removeEventListener('visibilitychange', this.onVisible);
        }

        tick() {
          clearTimeout(this.timeout);

          const remaining = this.end - Date.now();

          if (remaining <= 0) {
            this.querySelector('[data-segments]').hidden = true;
            this.querySelector('[data-divider]').hidden = true;
            this.querySelector('[data-expired]').hidden = false;
            return;
          }

          const total = Math.floor(remaining / 1000);

          this.set(this.els.days, Math.min(Math.floor(total / 86400), 99));
          this.set(this.els.hours, Math.floor((total % 86400) / 3600));
          this.set(this.els.minutes, Math.floor((total % 3600) / 60));
          this.set(this.els.seconds, total % 60);

          // Fire again exactly when the displayed second changes
          this.timeout = setTimeout(() => this.tick(), remaining % 1000 || 1000);
        }

        set(el, value) {
          const text = String(value).padStart(2, '0');
          if (el.textContent !== text) el.textContent = text;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('countdown-timer')) {
    customElements.define(
      'countdown-timer',
      class CountdownTimer extends HTMLElement {
        connectedCallback() {
          this.end = parseInt(this.dataset.end, 10) * 1000;
          if (!this.end) return;

          this.els = {
            days: this.querySelector('[data-days]'),
            hours: this.querySelector('[data-hours]'),
            minutes: this.querySelector('[data-minutes]'),
            seconds: this.querySelector('[data-seconds]'),
          };

          this.onVisible = () => {
            if (!document.hidden) this.tick();
          };
          document.addEventListener('visibilitychange', this.onVisible);

          this.tick();
        }

        disconnectedCallback() {
          clearTimeout(this.timeout);
          document.removeEventListener('visibilitychange', this.onVisible);
        }

        tick() {
          clearTimeout(this.timeout);

          const remaining = this.end - Date.now();

          if (remaining <= 0) {
            this.querySelector('[data-segments]').hidden = true;
            this.querySelector('[data-divider]').hidden = true;
            this.querySelector('[data-expired]').hidden = false;
            return;
          }

          const total = Math.floor(remaining / 1000);

          this.set(this.els.days, Math.min(Math.floor(total / 86400), 99));
          this.set(this.els.hours, Math.floor((total % 86400) / 3600));
          this.set(this.els.minutes, Math.floor((total % 3600) / 60));
          this.set(this.els.seconds, total % 60);

          // Fire again exactly when the displayed second changes
          this.timeout = setTimeout(() => this.tick(), remaining % 1000 || 1000);
        }

        set(el, value) {
          const text = String(value).padStart(2, '0');
          if (el.textContent !== text) el.textContent = text;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
